import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import { AddUnitPageLoader, AddUnitPageAction } from "./AddUnitPage/loaders";
import {
  UnitDetailsPageLoader,
  UnitDetailsPageAction,
  UnitDetailsLeaseLoader,
  UnitDetailsLeaseAction,
} from "./UnitDetailsPage/loaders";
import {
  UnitTablePageLoader,
  unitTableShouldRevalidate,
} from "./UnitTablePage/loaders";

const UnitTablePage = lazyNamedPage("UnitTablePage", () =>
  import(
    /* webpackChunkName: "unit" */
    "./UnitTablePage/UnitTablePage"
  ),
);
const AddUnitPage = lazyNamedPage("AddUnitPage", () =>
  import(/* webpackChunkName: "unit" */ "./AddUnitPage/AddUnitPage"),
);
const UnitDetailsPage = lazyNamedPage("UnitDetailsPage", () =>
  import(
    /* webpackChunkName: "unit" */
    "./UnitDetailsPage/UnitDetailsPage"
  ),
);
const UnitDetailsLease = lazyNamedPage("UnitDetailsLease", () =>
  import(
    /* webpackChunkName: "unit" */
    "./UnitDetailsPage/UnitDetailsLease"
  ),
);

/**
 * Public routes for Unit pages (accessible to unauthenticated users)
 * Returns only the table/list page route
 */
export const UnitPagesPublicRoutes = () => {
  return (
    <Route
      path="/unit"
      loader={UnitTablePageLoader}
      shouldRevalidate={unitTableShouldRevalidate}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<UnitTablePage />}
    />
  );
};

/**
 * Protected routes for Unit pages (require authentication)
 * Returns detail and add page routes
 */
export const UnitPagesProtectedRoutes = () => {
  return (
    <>
      <Route
        path="/add-unit"
        loader={AddUnitPageLoader}
        action={AddUnitPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AddUnitPage />}
      />
      <Route
        path="/unit/:unitID"
        loader={UnitDetailsPageLoader}
        action={UnitDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<UnitDetailsPage />}
      >
        <Route
          path="/unit/:unitID/lease"
          loader={UnitDetailsLeaseLoader}
          action={UnitDetailsLeaseAction}
          ErrorBoundary={() => SimpleErrorBoundary()}
          element={<UnitDetailsLease />}
        />
      </Route>
    </>
  );
};

/**
 * Legacy export - returns all routes (for backwards compatibility if needed)
 * @deprecated Use UnitPagesPublicRoutes() and UnitPagesProtectedRoutes() instead
 */
export const UnitPagesRoutes = () => {
  return (
    <>
      {UnitPagesPublicRoutes()}
      {UnitPagesProtectedRoutes()}
    </>
  );
};
